import { render, staticRenderFns } from "./icp.vue?vue&type=template&id=11cc4565&"
import script from "./icp.vue?vue&type=script&lang=js&"
export * from "./icp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports